module.exports = __webpack_public_path__ + "res/dummy_prediction1.73bbf1e653afd749b1b69fc8192fc66a.png";